<template>
  <div>
    <nav>
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <a
          v-if="permission('read', 'resident_annotation')"
          @click="handleStep('ANOTACAO_DE_ENFERMAGEM')"
          :class="[
            'nav-link link-nav-resident',
            step == 'ANOTACAO_DE_ENFERMAGEM' && 'active',
          ]"
          id="nav-anotacao-de-enfermagem"
          data-toggle="tab"
          href="#anotacao-de-enfermagem"
          role="tab"
          aria-controls="anotacao-de-enfermagem"
          aria-selected="true"
          >ANOTAÇÃO DE CUIDADOS</a
        >
        <a
          v-if="permission('read', 'resident_vital_signs')"
          @click="handleStep('SINAIS_VITAIS')"
          :class="[
            'nav-link link-nav-resident',
            step == 'SINAIS_VITAIS' && 'active',
          ]"
          id="nav-sinais-vitais"
          data-toggle="tab"
          href="#sinais-vitais"
          role="tab"
          aria-controls="sinais-vitais"
          aria-selected="true"
          >SINAIS VITAIS</a
        >
        <a
          v-if="permission('read', 'resident_daily_routine_medicine_check')"
          @click="handleStep('CHECAGEM')"
          :class="[
            'nav-link link-nav-resident',
            step == 'CHECAGEM' && 'active',
          ]"
          id="nav-checagem"
          data-toggle="tab"
          href="#checagem"
          role="tab"
          aria-controls="checagem"
          aria-selected="true"
          >CHECAGEM DE MEDICAMENTOS</a
        >
        <a
          v-if="permission('read', 'resident_daily_routine_check_prescription')"
          @click="handleStep('PRESCRICAO')"
          :class="[
            'nav-link link-nav-resident',
            step == 'PRESCRICAO' && 'active',
          ]"
          id="nav-prescricao-normal"
          data-toggle="tab"
          href="#prescricao-normal"
          role="tab"
          aria-controls="prescricao-normal"
          aria-selected="false"
          >PRESCRIÇÃO DE CHECAGEM</a
        >
        <a
          v-if="permission('read', 'resident_daily_routine_check_prescription')"
          @click="handleStep('PRESCRICAO_LONGO_PRAZO')"
          :class="[
            'nav-link link-nav-resident',
            step == 'PRESCRICAO_LONGO_PRAZO' && 'active',
          ]"
          id="nav-prescricao-longo-prazo"
          data-toggle="tab"
          href="#prescricao-longo-prazo"
          role="tab"
          aria-controls="prescricao-longo-prazo"
          aria-selected="false"
          >PRESCRIÇÃO DE CHECAGEM LONGO PRAZO</a
        >
      </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
      <div
        v-if="step == 'ANOTACAO_DE_ENFERMAGEM'"
        :class="[
          'tab-pane',
          step == 'ANOTACAO_DE_ENFERMAGEM' ? 'show active' : 'fade',
        ]"
        id="anotacao-de-enfermagem"
        role="tabpanel"
        aria-labelledby="nav-anotacao-de-enfermagem"
      >
        <Annotation :type_of_food="type_of_food" />
      </div>
      <div
        v-if="step == 'SINAIS_VITAIS'"
        :class="['tab-pane', step == 'SINAIS_VITAIS' ? 'show active' : 'fade']"
        id="sinais-vitais"
        role="tabpanel"
        aria-labelledby="nav-sinais-vitais"
      >
        <VitalSigns />
      </div>
      <div
        v-if="step == 'CHECAGEM'"
        :class="['tab-pane', step == 'CHECAGEM' ? 'show active' : 'fade']"
        id="checagem"
        role="tabpanel"
        aria-labelledby="nav-checagem"
      >
        <CheckNormal v-on:checked="$emit('checked')" />
      </div>
      <div
        v-if="step == 'PRESCRICAO'"
        :class="['tab-pane', step == 'PRESCRICAO' ? 'show active' : 'fade']"
        id="prescricao-normal"
        role="tabpanel"
        aria-labelledby="nav-prescricao-normal"
      >
        <PrescriptionNormal />
      </div>
      <div
        v-if="step == 'PRESCRICAO_LONGO_PRAZO'"
        :class="[
          'tab-pane',
          step == 'PRESCRICAO_LONGO_PRAZO' ? 'show active' : 'fade',
        ]"
        id="prescricao-longo-prazo"
        role="tabpanel"
        aria-labelledby="nav-prescricao-longo-prazo"
      >
        <PrescriptionLongTerm />
      </div>
    </div>
  </div>
</template>

<script>
import Annotation from "./DailyRoutine/Annotation";

import VitalSigns from "./DailyRoutine/VitalSigns";

import CheckNormal from "./DailyRoutine/Check/Normal";

import PrescriptionNormal from "./DailyRoutine/Prescription/Normal";

import PrescriptionLongTerm from "./DailyRoutine/Prescription/LongTerm";

import routes from "../../routes";

import { userData } from "../../lib/functions";

import permission from "../../lib/permission";

export default {
  name: "MenuDailyRoutine",
  components: {
    Annotation,
    VitalSigns,
    CheckNormal,
    PrescriptionNormal,
    PrescriptionLongTerm,
  },
  props: {
    type_of_food: [Number, String, undefined],
  },
  data() {
    return {
      step: "ANOTACAO_DE_ENFERMAGEM",
      permissions: {},
      rest_home_id: "",
      resident_id: "",
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    permission,
    handleStep(step) {
      let newNav;

      if (step == "ANOTACAO_DE_ENFERMAGEM") {
        newNav = "annotation";
      }

      if (step == "SINAIS_VITAIS") {
        newNav = "vital-signs";
      }

      if (step == "CHECAGEM") {
        newNav = "check";
      }

      if (step == "PRESCRICAO") {
        newNav = "prescription";
      }

      let { tab, nav } = routes.history.current.query;

      if (nav != newNav) {
        routes.replace({ query: { tab, nav: newNav } });
      }

      this.step = step;
    },
    async retrieve() {
      let { rest_home_id, permissions } = userData();

      this.rest_home_id = rest_home_id;

      this.permissions = permissions;

      const { id } = routes.history.current.params;

      this.resident_id = id;

      const { nav } = routes.history.current.query;

      if (nav) {
        if (nav == "annotation") {
          this.step = "ANOTACAO_DE_ENFERMAGEM";
        }

        if (nav == "vital-signs") {
          this.step = "SINAIS_VITAIS";
        }

        if (nav == "check") {
          this.step = "CHECAGEM";
        }

        if (nav == "prescription") {
          this.step = "PRESCRICAO";
        }
      }
    },
  },
};
</script>
